module.exports = __webpack_public_path__ + "static/media/place_bets.8cda44fa.mp3";